import React from 'react';
import { Reconciliation } from '../types';

/**
 * Stanje podataka, uvek vidljivo.
 *
 * Ako se saldo konektora ne poklapa sa ERP-om, operater to mora videti pre nego
 * što išta isplanira — pogrešna lista je gora od nikakve.
 */
export default function DataHealth({ report }: { report: Reconciliation | null }) {
  if (!report) {
    return <div className="health health--unknown">Provera podataka nije učitana.</div>;
  }

  if (!report.balances) {
    return (
      <div className="health health--bad">
        <strong>Podaci se ne slažu sa ERP-om.</strong> ERP ima {report.erp.quantity} kom
        na {report.erp.articles} artikala, a lista prikazuje {report.reported.quantity} kom
        na {report.reported.articles}. Ne planirati dok se ovo ne razjasni.
      </div>
    );
  }

  const { resolved, needsReview, resolutionRate } = report.destinations;

  return (
    <div className="health health--ok">
      Saldo se poklapa sa ERP-om: {report.erp.quantity} kom na {report.erp.articles} artikala.
      {needsReview > 0 && (
        <>
          {' '}Odredište razrešeno za {resolutionRate}% količine — <strong>{needsReview}</strong> stavki
          čeka tvoju potvrdu, {resolved} je spremno.
        </>
      )}
    </div>
  );
}
